import { useTranslation } from "react-i18next";
import type { SegmentedControlOption } from "src/common/components/SegmentedControl/SegmentedControl";
import type { RankingEntityType } from "../hooks/useRankingData";

export const useRankingTabOptions = (
  showGroupTabs = false,
): SegmentedControlOption<RankingEntityType>[] => {
  const { t } = useTranslation();

  const baseTabs: SegmentedControlOption<RankingEntityType>[] = [
    { value: "parcours", label: t("statsNew.classement.subTabs.parcours") },
    { value: "modules", label: t("statsNew.classement.subTabs.modules") },
    { value: "apprenants", label: t("statsNew.classement.subTabs.apprenants") },
  ];

  if (!showGroupTabs) return baseTabs;

  return [
    ...baseTabs,
    { value: "groupes", label: t("statsNew.classement.subTabs.groupes") },
    { value: "groupes_parcours", label: t("statsNew.classement.subTabs.groupesParcours") },
  ];
};
